"use strict";
var GpmlUtilities = require("./gpml-utilities");
var GRAPHICAL_LINE_DEFAULTS = {
    attributes: {
        Color: {
            name: 'Color',
            value: '000000'
        },
        ConnectorType: {
            name: 'ConnectorType',
            value: 'Straight'
        },
        FillColor: {
            name: 'FillColor',
            value: 'Transparent'
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        }
    }
};
function applyDefaults(gpmlElement, defaults) {
    gpmlElement = GpmlUtilities.applyDefaults(gpmlElement, [GRAPHICAL_LINE_DEFAULTS, defaults]);
    return gpmlElement;
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JhcGhpY2FsLWxpbmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ3JhcGhpY2FsLWxpbmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGdEQUFrRDtBQUVsRCxJQUFNLHVCQUF1QixHQUFHO0lBQy9CLFVBQVUsRUFBRTtRQUNYLEtBQUssRUFBRTtZQUNOLElBQUksRUFBRSxPQUFPO1lBQ2IsS0FBSyxFQUFFLFFBQVE7U0FDZjtRQUNELGFBQWEsRUFBRTtZQUNkLElBQUksRUFBRSxlQUFlO1lBQ3JCLEtBQUssRUFBRSxVQUFVO1NBQ2pCO1FBQ0QsU0FBUyxFQUFFO1lBQ1YsSUFBSSxFQUFFLFdBQVc7WUFDakIsS0FBSyxFQUFFLGFBQWE7U0FDcEI7UUFDRCxhQUFhLEVBQUU7WUFDZCxJQUFJLEVBQUUsZUFBZTtZQUNyQixLQUFLLEVBQUUsQ0FBQztTQUNSO0tBQ0Q7Q0FDRCxDQUFDO0FBRUYsdUJBQThCLFdBQVcsRUFBRSxRQUFRO0lBQ2xELFdBQVcsR0FBRyxhQUFhLENBQUMsYUFBYSxDQUFDLFdBQVcsRUFBRSxDQUFDLHVCQUF1QixFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUM7SUFDNUYsTUFBTSxDQUFDLFdBQVcsQ0FBQztBQUNwQixDQUFDO0FBSEQsc0NBR0M7QUFBQSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/graphical-line.js
// module id = 707
// module chunks = 0